import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * LegalFooter — single reusable legal footer used at the bottom of the
 * dashboard (admin + merchant) and at the bottom of the public game page.
 *
 * Renders 3 discreet links: Mentions légales · Confidentialité · Organiser
 * mon concours. `variant="light"` switches to white text for dark
 * backgrounds (e.g. ClaimPage).
 */
export default function LegalFooter({ className = "", variant = "default" }) {
  const { t } = useTranslation();
  const base =
    variant === "light"
      ? "text-white/80 hover:text-white"
      : "text-foreground/70 hover:text-foreground";
  return (
    <div
      className={`flex items-center justify-center gap-x-3 gap-y-1 flex-wrap text-[12px] ${className}`}
      data-testid="legal-footer"
    >
      <Link
        to="/conditions#mentions-legales"
        className={`underline underline-offset-2 ${base}`}
        data-testid="legal-footer-legal"
      >
        {t("play.legal_notice")}
      </Link>
      <span className={variant === "light" ? "text-white/50" : "text-muted-foreground/50"}>
        ·
      </span>
      <Link
        to="/conditions#confidentialite"
        className={`underline underline-offset-2 ${base}`}
        data-testid="legal-footer-privacy"
      >
        {t("play.legal_privacy")}
      </Link>
      <span className={variant === "light" ? "text-white/50" : "text-muted-foreground/50"}>
        ·
      </span>
      <Link
        to="/organiser-un-concours"
        className={`underline underline-offset-2 ${base}`}
        data-testid="legal-footer-contact"
      >
        {t("play.legal_run_contest")}
      </Link>
    </div>
  );
}
